import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const exportToPDF = async (elementId, filename = 'export.pdf') => {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error('Element not found:', elementId);
    return false;
  }
  
  try {
    // Show loading state
    const loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'pdf-loading-overlay';
    loadingOverlay.innerHTML = `
      <div style="
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      ">
        <div style="
          background: white;
          padding: 24px 48px;
          border-radius: 16px;
          text-align: center;
          box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);
        ">
          <div style="
            width: 48px;
            height: 48px;
            border: 4px solid #e5e7eb;
            border-top-color: #8b5cf6;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 16px;
          "></div>
          <p style="margin: 0; color: #374151; font-weight: 500;">Generating PDF...</p>
        </div>
      </div>
      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;
    document.body.appendChild(loadingOverlay);
    
    // Wait a bit for any animations to settle
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Capture the element
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
    });
    
    // A4 dimensions in mm
    const a4Width = 210;
    const a4Height = 297;
    
    // Calculate dimensions to fit A4
    const imgWidth = a4Width;
    const imgHeight = (canvas.height * a4Width) / canvas.width;
    
    // Create PDF
    const pdf = new jsPDF({
      orientation: imgHeight > a4Height ? 'portrait' : 'landscape',
      unit: 'mm',
      format: 'a4',
    });
    
    // Add pages if content is longer than A4
    let position = 0;
    let remainingHeight = imgHeight;
    
    while (remainingHeight > 0) {
      if (position > 0) {
        pdf.addPage();
      }
      
      const pageHeight = pdf.internal.pageSize.getHeight();
      const sourceY = (position / imgHeight) * canvas.height;
      const sourceHeight = (pageHeight / imgHeight) * canvas.height;
      
      // Create a canvas for this page section
      const pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvas.width;
      pageCanvas.height = Math.min(sourceHeight, canvas.height - sourceY);
      
      const ctx = pageCanvas.getContext('2d');
      ctx.drawImage(
        canvas,
        0, sourceY,
        canvas.width, pageCanvas.height,
        0, 0,
        canvas.width, pageCanvas.height
      );
      
      const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.95);
      const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;
      
      pdf.addImage(pageImgData, 'JPEG', 0, 0, imgWidth, pageImgHeight);
      
      position += pageHeight;
      remainingHeight -= pageHeight;
    }
    
    // Save the PDF
    pdf.save(filename);
    
    // Remove loading overlay
    document.body.removeChild(loadingOverlay);
    
    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    const overlay = document.getElementById('pdf-loading-overlay');
    if (overlay) document.body.removeChild(overlay);
    return false;
  }
};

export default exportToPDF;
